import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { ServiceManagementRequirement } from './service-management-requirement.model';
import * as ServiceManagementRequirementActions from './service-management-requirement.actions';

export const serviceManagementRequirementsFeatureKey = 'serviceManagementRequirements';

export interface State extends EntityState<ServiceManagementRequirement> {
  // additional entities state properties
}

export const adapter: EntityAdapter<ServiceManagementRequirement> = createEntityAdapter<ServiceManagementRequirement>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(ServiceManagementRequirementActions.addServiceManagementRequirement,
    (state, action) => adapter.addOne(action.serviceManagementRequirement, state)
  ),
  on(ServiceManagementRequirementActions.upsertServiceManagementRequirement,
    (state, action) => adapter.upsertOne(action.serviceManagementRequirement, state)
  ),
  on(ServiceManagementRequirementActions.addServiceManagementRequirements,
    (state, action) => adapter.addMany(action.serviceManagementRequirements, state)
  ),
  on(ServiceManagementRequirementActions.upsertServiceManagementRequirements,
    (state, action) => adapter.upsertMany(action.serviceManagementRequirements, state)
  ),
  on(ServiceManagementRequirementActions.updateServiceManagementRequirement,
    (state, action) => adapter.updateOne(action.serviceManagementRequirement, state)
  ),
  on(ServiceManagementRequirementActions.updateServiceManagementRequirements,
    (state, action) => adapter.updateMany(action.serviceManagementRequirements, state)
  ),
  on(ServiceManagementRequirementActions.deleteServiceManagementRequirement,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(ServiceManagementRequirementActions.deleteServiceManagementRequirements,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(ServiceManagementRequirementActions.loadServiceManagementRequirements,
    (state, action) => adapter.setAll(action.serviceManagementRequirements, state)
  ),
  on(ServiceManagementRequirementActions.clearServiceManagementRequirements,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
